import classNames from 'classnames';
import type { IconComponent } from '@alltrails/denali/components/Icon';
import IconTile from '@alltrails/denali/components/IconTile';
import ChevronSm from '@alltrails/denali/icons/ChevronSm';
import styles from './PlanYourVisit.module.scss';

type HelpfulLinkTagProps = {
  className?: string;
  icon: IconComponent;
  /** 'weak' renders an outlined tile, for use on light card backgrounds */
  iconEmphasis?: 'base' | 'weak';
  id: string;
  label: string;
  onClick: (id: string) => void;
};

const HelpfulLinkTag = ({ className, icon, iconEmphasis = 'base', id, label, onClick }: HelpfulLinkTagProps) => {
  return (
    <button className={classNames(styles.helpfulLinkTag, className)} onClick={() => onClick(id)} title={label}>
      <IconTile emphasis={iconEmphasis} icon={{ Component: icon }} radius="circle" />
      <div className={styles.helpfulLinkTagLabel}>
        <div className={styles.tagName}>{label}</div>
        <ChevronSm orientation="right" />
      </div>
    </button>
  );
};

export default HelpfulLinkTag;
